
const NorthernTrustCustody = () => {
  return (
     <section>
      <p>
        Northern Trust Custody Integration Northern Trust is the institutional
        custodian responsible for holding the cash reserves backing USCY in a
        fully segregated, audit-ready account structure. Account Structure
        Reserves are held in the account: “Brale FBO USCY Reserves Trust” This
        ensures: Beneficial ownership sits with the Trust Funds are treated as
        client assets Brale acts only as an administrative agent Custody
        Guarantees No rehypothecation Segregated accounts Daily statements SOC2
        / ISO27001 compliant environment Institutional-grade risk controls
        Supports large-scale settlement and treasury operations Role in System
        Northern Trust provides the safeguarding layer in the USCY architecture,
        ensuring reserve integrity and redeemability. Related Concepts USCY
        Reserves Trust USCY
      </p>
    </section>
  )
}

export default NorthernTrustCustody